import Logo from "../../assets/images/mtstaj1.png";
import Instagram from "../../assets/images/instagram.png";
import Facebook from "../../assets/images/facebook.png";
import Twitter from "../../assets/images/twitter.png";
import UcIk from "../../assets/images/UcIk.png";

const Footer = () => {
  return (
    <section className="w-full flex justify-center py-5 bg-[#FFF8EB]">
      <div className="w-4/5 lg:w-4/6 max-w-screen-xl flex flex-row justify-between items-center">
        <img
          onClick={() => {
            window.scrollTo(0, 0);
          }}
          loading="lazy"
          className="cursor-pointer w-12 lg:w-[93px]"
          src={Logo}
          alt="mtstaj"
        />
        <ul className="flex flex-row space-x-3 items-center w-full justify-center lg:justify-end px-12">
          <li>
            <a href="https://tr-tr.facebook.com/MTStajProgramlari/">
              <img
                loading="lazy"
                className="w-7 lg:w-[37.35px]"
                src={Facebook}
                alt="facebook"
              />
            </a>
          </li>
          <li>
            <a href="https://www.instagram.com/mtstajprogramlari/">
              <img
                loading="lazy"
                className="w-7 lg:w-[37.35px]"
                src={Instagram}
                alt="instagram"
              />
            </a>
          </li>
          <li>
            <a href="https://twitter.com/mtstaj">
              <img
                loading="lazy"
                className="w-7 lg:w-[37.35px]"
                src={Twitter}
                alt="twitter"
              />
            </a>
          </li>
        </ul>
        <a href="/">
          <img
            loading="lazy"
            className="w-12 lg:w-[83px]"
            src={UcIk}
            alt="3IK"
          />
        </a>
      </div>
    </section>
  );
};

export default Footer;
